// extracted by mini-css-extract-plugin
export default {"items":"Halls_items__zLo6c"};